<template>
  <div class="paruse">
    <div class="shop_top">
      <shop-top :subnav_show="subnav_show" :change_color="true"></shop-top>
    </div>

    <div v-loading="loading" class="content-box">
      <div class="title">{{ info.title }}</div>
      <div v-html="info.contents"></div>
    </div>

    <shop-foot></shop-foot>
    <!-- vue 回到顶部 -->
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import ShopTop from "@/components/ShopHead/index"
import ShopFoot from "@/components/ShopFoot/index"
import { getagreement } from "@/api/home"
export default {
  components: {
    ShopTop,
    ShopFoot,
  },
  props: {},
  data () {
    return {
      subnav_show: false,
      loading: false,
      info: {},
    }
  },
  created () {
    this.getInfo()
  },
  methods: {
    async getInfo () {
      this.loading = true
      getagreement({
        keyword: "contactservicekey",
      }).then(({ data }) => {
        this.loading = false
        this.info = data
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.content-box {
  width: 1160px;
  min-height: 700px;
  background: #fff;
  border-radius: 12px;
  margin: 20px auto 80px;
  padding: 20px;
  .title {
    text-align: center;
    font-size: 16px;
    color: #333;
    padding: 10px 0 30px;
    font-weight: 550;
  }
}
</style>